import React from 'react';
import './ElevationPage.css';
import useScrollToTop from './useScrollToTop'; // Create ElevationPage.css
import ReusableLanding from './ReusableLanding';
import FAQ from './FAQ';
import landimg from '../img/13-best-tools-cover.jpg';
import image1 from '../img/elevation_img_1.jpeg';
import image2 from '../img/elevation_img_2.jpeg';
import image3 from '../img/elevation_img_3.jpeg';
import image4 from '../img/elevation_img_4.jpeg';
import image5 from '../img/elevation_img_5.jpeg';
import image6 from '../img/elevation_img_6.jpeg';
import image7 from '../img/elevation_img_7.jpeg';
import image8 from '../img/elevation_img_8.jpeg';
import image9 from '../img/elevation_img_9.jpeg';
import image10 from '../img/elevation_img_10.jpeg';
import image11 from '../img/elevation_img_11.jpeg';
import image12 from '../img/elevation_img_12.jpeg';
import image13 from '../img/elevation_img_13.jpeg';
import image14 from '../img/elevation_img_14.jpeg';
import image15 from '../img/elevation_img_15.jpeg';
import image18 from '../img/elevation_img_17.jpg';
import image19 from '../img/elevation_img_18.jpg';
import image20 from '../img/elevation_img_19.jpg';
import image21 from '../img/elevation_img_20.jpg';
import image22 from '../img/elevation_img_21.jpg';
import image23 from '../img/elevation_img_22.jpg';
import image24 from '../img/elevation_img_23.jpg';
import image25 from '../img/elevation_img_24.jpg';
import image26 from '../img/elevation_img_25.jpg';
import image27 from '../img/elevation_img_26.jpg';
import image28 from '../img/elevation_img_27.jpg';
import image29 from '../img/elevation_img_28.jpg';
import image30 from '../img/elevation_img_29.jpg';
import elevationFAQData from './ElevationFAQData';
import InquiryForm from './InquiryForm';
import ServiceFeatures from './ServiceFeatures';
import { FaSyncAlt, FaComments,FaCheckCircle } from 'react-icons/fa';

const ElevationPage = () => {
useScrollToTop();
const elevations = [
    {
      id: 1,
      image: image18, // Using image17 - Note: You might want to double-check if this was intentional
      description: 'A detailed front elevation showcasing the modern design and architectural features.',
    },
    {
      id: 2,
      image: image18, // Using image18
      description: 'A side elevation highlighting the building’s structural design and material choices.',
    },
    {
      id: 3,
      image: image19, // Using image19
      description: 'The rear elevation view of the renovated house, displaying the updated design and layout.',
    },
    {
      id: 4,
      image: image20, // Using image20
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 5,
      image: image21,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 6,
      image: image22,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 7,
      image: image23,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 8,
      image: image24,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 9,
      image: image25,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 10,
      image: image26,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 11,
      image: image27,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 12,
      image: image28,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 13,
      image: image29,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 14,
      image: image30,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 16,
      image: image1,
      description: 'Elevation view showcasing the modern facade of a commercial building with large glass windows.',
    },
    {
      id: 17,
      image: image2,
      description: 'Detailed elevation of a luxury apartment complex, showing the intricate design and high-quality finishes.',
    },
    {
      id: 18,
      image: image3,
      description: 'Side elevation of a contemporary house featuring a sloped roof and unique architectural elements.',
    },
    {
      id: 19,
      image: image4,
      description: 'Front elevation of a traditional brick building with arched windows and classic detailing.',
    },
    {
      id: 20,
      image: image5,
      description: 'Rear elevation of a residential building highlighting balconies and outdoor living spaces.',
    },
    {
      id: 21,
      image: image6,
      description: 'Elevation of a modern office building with a curtain wall system and sleek design.',
    },
    {
      id: 22,
      image: image7,
      description: 'Detailed elevation of a townhouse complex showcasing individual unit designs and shared spaces.',
    },
    {
      id: 23,
      image: image8,
      description: 'Front elevation of a charming cottage with a garden and traditional architectural features.',
    },
    {
      id: 24,
      image: image9,
      description: 'Side elevation of an industrial building with functional design and robust materials.',
    },
    {
      id: 25,
      image: image10,
      description: 'Rear elevation of a mixed-use development combining residential and commercial spaces.',
    },
    {
      id: 26,
      image: image11,
      description: 'Elevation of a high-rise building emphasizing its height and urban context.',
    },
    {
      id: 27,
      image: image12,
      description: 'Detailed elevation of a cultural center with unique architectural forms and materials.',
    },
    {
      id: 28,
      image: image13,
      description: 'Front elevation of a suburban home with a garage and landscaped yard.',
    },
    {
      id: 29,
      image: image14,
      description: 'Side elevation of an educational building showcasing its layout and facilities.',
    },
    {
      id: 30,
      image: image15,
      description: 'Rear elevation of a hospitality building with amenities like pools and terraces.',
    },
  ];

const featuresData = [
    {
      icon: <FaSyncAlt />,
      text: 'Multiple design revisions',
    },
    {
      icon: <FaComments />,
      text: 'Free consultation with experts',
    },
    {
      icon: <FaCheckCircle />,
      text: '100% satisfaction guarantee',
    },
];

 return (
    <>
      <ReusableLanding
        imageUrl={landimg}
        title="Architectural Elevations: Visualize Your Home's Exterior"
        description="Explore detailed elevation drawings showcasing the exterior design and architectural features of our custom home projects."
      />
      <div className="elevation-page">
        <h1>House Elevation Designs - 3D Front Elevation Designs</h1>
        <div className="elevation-description">
          <p>
            3D House elevation designs can help visualize the proposed appearance of the exterior view and design of the house from any side e.g. front, back, corner or any other side. The main purpose of the building elevation design is to help you visualize the finished appearance of the exterior design of a building from a particular side or corner.
          </p>
          <p>
            Front house elevation design can show you the appearance of the building from the front side. Similarly, back elevation design of the building can show the finished appearance of the building from the back side. 3D Building elevation designs can be created for all sides and corners of the building, including day view and night view of the building.
          </p>
        </div>
        <div className="elevation-grid">
          {elevations.map((elevation) => (
            <div className="elevation-card" key={elevation.id}>
              <img src={elevation.image} alt={elevation.title} className="elevation-image" />
              <div className="elevation-details">
                <h2>{elevation.title}</h2>
                <p>{elevation.description}</p>
              </div>
            </div>
          ))}
        </div>
  
        <div className="elevation-construction">
          <div className="elevation-content">
            <h2>Architectural Elevations: Building Your Vision</h2>
            <p>
              Architectural elevations are orthographic projections that show the exterior
              sides of a building. They provide a clear view of the building's facade,
              including its height, width, and architectural features.
            </p>
  
            <h3>Why Elevations Are Important</h3>
            <ul>
              <li>
                <strong>Visual Representation:</strong> Elevations help visualize the final
                appearance of the building.
              </li>
              <li>
                <strong>Construction Guidance:</strong> They provide precise measurements
                and details for builders.
              </li>
              <li>
                <strong>Design Communication:</strong> Elevations facilitate communication
                between designers, clients, and contractors.
              </li>
              <li>
                <strong>Aesthetic Planning:</strong> they help to plan the look and feel of the outside of the home.
              </li>
            </ul>
  
            <h3>Our Elevation Design Services</h3>
            <p>
              We create detailed and accurate elevation drawings, including:
            </p>
            <ul>
              <li>Front elevations</li>
              <li>Rear elevations</li>
              <li>Side elevations</li>
              <li>3D elevation renderings</li>
              <li>Day and night views</li>
            </ul>
  
            <div className="elevation-examples">
              <h3>Elevation Examples</h3>
              <div className="elevation-image-container">
                <img src={image18} alt="Front Elevation Example" />
                <img src={image24} alt="Side Elevation Example" />
                <img src={image30} alt="3D Elevation Example" />
              </div>
            </div>
          </div>
        </div>
  
        <InquiryForm />
        <FAQ faqData={elevationFAQData} />
        <ServiceFeatures features={featuresData} />
      </div>
    </>
  );
};

export default ElevationPage;